import React from "react";
import FloatingMacarons from "../components/FloatingMacarons";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";

import macaronStrawberry from "../assets/macaron-strawberry.png";
import macaronVanilla    from "../assets/macaron-vanilla.png";
import macaronEspresso   from "../assets/macaron-chocolate.png";
import macaronToastedCoconut from "../assets/macaron-toasted-coconut.png";

const ALL_FLAVORS = [
  { id: "vanilla",         name: "Vanilla",        description: "Filled with a smooth vanilla buttercream",                        image: macaronVanilla    },
  { id: "strawberry",      name: "Strawberry",     description: "Filled with a sweet strawberry buttercream",                      image: macaronStrawberry },
  { id: "espresso",        name: "Espresso",       description: "Filled with a rich espresso buttercream",                         image: macaronEspresso   },
  { id: "toasted-coconut", name: "Toasted Coconut", description: "Filled with a toasted coconut buttercream",                       image: macaronToastedCoconut },
  // { id: "lemon",      name: "Lemon",           description: "Filled with a classic buttercream and smooth lemon curd",           image: macaronLemon,      comingSoon: true },
  // { id: "peach",      name: "Peach",           description: "Filled with a fruity peach buttercream",                           image: macaronPeach,      comingSoon: true },
  // { id: "peppermint", name: "Peppermint",      description: "Filled with a cool peppermint buttercream and crushed peppermints", image: macaronPeppermint, comingSoon: true },
];

const HERO_MACARONS = [
  { top: "15%", left: "2%",  delay: 0.0, size: 54 },
  { top: "50%", left: "8%",  delay: 1.2, size: 46 },
  { top: "80%", left: "2%",  delay: 2.4, size: 50 },
  { top: "15%", left: "92%", delay: 0.6, size: 50 },
  { top: "50%", left: "84%", delay: 1.8, size: 44 },
  { top: "80%", left: "92%", delay: 3.0, size: 52 },
];

const CONTENT_MACARONS = [
  { top: "3%",  left: "8%",  delay: 0.2, size: 44 },
  { top: "14%", left: "2%",  delay: 1.5, size: 34 },
  { top: "25%", left: "8%",  delay: 0.8, size: 50 },
  { top: "36%", left: "2%",  delay: 2.0, size: 36 },
  { top: "47%", left: "8%",  delay: 0.4, size: 44 },
  { top: "58%", left: "2%",  delay: 1.3, size: 34 },
  { top: "69%", left: "8%",  delay: 0.9, size: 48 },
  { top: "80%", left: "2%",  delay: 1.7, size: 36 },
  { top: "91%", left: "8%",  delay: 0.5, size: 42 },
  { top: "3%",  left: "84%", delay: 0.6, size: 40 },
  { top: "14%", left: "92%", delay: 1.9, size: 50 },
  { top: "25%", left: "84%", delay: 0.1, size: 34 },
  { top: "36%", left: "92%", delay: 2.3, size: 46 },
  { top: "47%", left: "84%", delay: 0.7, size: 36 },
  { top: "58%", left: "92%", delay: 1.4, size: 52 },
  { top: "69%", left: "84%", delay: 0.3, size: 34 },
  { top: "80%", left: "92%", delay: 2.1, size: 44 },
  { top: "91%", left: "84%", delay: 1.0, size: 38 },
];

function FlavorShowcaseCard({ flavor }) {
  const inner = (
    <div className={`card p-6 flex flex-col items-center text-center transition-shadow h-full ${flavor.comingSoon ? "opacity-70" : "hover:shadow-md cursor-pointer"}`}>
      <div className="relative">
        <img src={flavor.image} alt={flavor.name} className="w-32 h-32 object-contain mb-4 drop-shadow-sm" />
        {flavor.comingSoon && (
          <span className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-full">Coming Soon</span>
        )}
      </div>
      <h3 className="font-display text-xl text-sage-800 mb-1">{flavor.name}</h3>
      <p className="text-sm text-gray-500 leading-relaxed">{flavor.description}</p>
      <span className="mt-3 text-xs bg-green-50 text-green-700 px-2 py-0.5 rounded-full font-bold">Gluten Free</span>
    </div>
  );

  if (flavor.comingSoon) return inner;
  return <Link to={`/order-now?flavor=${flavor.id}`} className="block h-full">{inner}</Link>;
}

export default function Menu() {
  return (
    <div className="pt-20">
      <section className="relative text-center py-16 px-4 bg-gradient-to-b from-cream-100 to-cream-50 overflow-hidden">
        <FloatingMacarons positions={HERO_MACARONS} heroOnly />
        <p className="font-handwrite text-sage-500 text-xl mb-2">What's baking?</p>
        <h1 className="font-display text-4xl text-sage-900 mb-3">Our Menu</h1>
        <p className="text-gray-500 text-sm leading-relaxed max-w-md mx-auto">
          All macarons are 100% gluten free, made fresh to order.
        </p>
        <br />
      </section>

      <section className="relative bg-cream-50 pt-2 pb-16 px-4 overflow-hidden">
        <FloatingMacarons positions={CONTENT_MACARONS} />
        <div className="relative max-w-2xl mx-auto space-y-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {ALL_FLAVORS.map((flavor) => (
              <FlavorShowcaseCard key={flavor.id} flavor={flavor} />
            ))}
          </div>
          <div className="bg-cream-100 rounded-xl p-4 text-xs text-gray-500 leading-relaxed">
            <strong className="text-sage-700">Allergen Notice:</strong> All products are gluten free
            and made in a dedicated gluten-free kitchen. Products contain eggs, dairy, and tree nuts (almond flour).
          </div>
        </div>
        <br />
        <div className="text-center py-4">
          <p className="font-handwrite text-sage-500 text-xl mb-2">Ready to place an order?</p>
          <Link to="/order-now" className="btn-primary inline-flex items-center gap-2">
            <ShoppingBag size={16} />
            Choose Your Box
          </Link>
        </div>
      </section>
    </div>
  );
}